import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PetHomePromotionNovember from './routes/PetHomePromotion';
import PetHomePromotionDecember from './routes/PetHomePromotionDecember';
import PetHomePromotionJanuray from './routes/PetHomePromotionJanuary';
import PetHomePromotionFebruary from './routes/PetHomePromotionFebruary';
import PetHomePromotionMarch from './routes/PetHomePromotionMarch';

export default class PetHomeIndexComponent extends Component {
	render() {
		return (
			<Switch>
				<Route
					path='/pet-home/promotion/november'
					component={PetHomePromotionNovember}
					exact
				/>
				<Route
					path='/pet-home/promotion/december'
					component={PetHomePromotionDecember}
					exact
				/>
				<Route
					path='/pet-home/promotion/january'
					component={PetHomePromotionJanuray}
					exact
				/>
				<Route
					path='/pet-home/promotion/february'
					component={PetHomePromotionFebruary}
					exact
				/>
				<Route
					path='/pet-home/promotion/march'
					component={PetHomePromotionMarch}
					exact
				/>
			</Switch>
		);
	}
}
